<template>
  <v-btn-toggle mandatory style="width: 100%">
    <v-btn
      large
      v-for="item in items"
      :key="item.status"
      @click="setGroupTypeLive(item.value)"
      style="flex: 1"
    >
      {{ item.text }}
    </v-btn>
  </v-btn-toggle>
</template>
<script>
export default {
  name: "components-common-filters-group-status",
  data: () => ({}),
  computed: {
    items() {
      return [
        { text: this.$t("general"), value: "" },
        { text: this.$t("live"), value: "live" },
      ];
    },
  },
  methods: {
    setGroupTypeLive(value) {
      this.$store.commit("setGroupTypeLive", value);
    },
  },
};
</script>
